import { Phone, Mail, MapPin, MessageCircle } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <h3 className="text-xl font-bold text-orange-400 mb-4">Vrindavan Calling</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Your trusted real estate consultant for MVDA & RERA approved properties in Vrindavan and Mathura.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold mb-4 text-white">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#home" className="text-gray-400 hover:text-orange-400 transition-colors duration-200">
                  Home
                </a>
              </li>
              <li>
                <a href="#properties" className="text-gray-400 hover:text-orange-400 transition-colors duration-200">
                  Properties
                </a>
              </li>
              <li>
                <a href="#about" className="text-gray-400 hover:text-orange-400 transition-colors duration-200">
                  About Us
                </a>
              </li>
              <li>
                <a href="#locations" className="text-gray-400 hover:text-orange-400 transition-colors duration-200">
                  Locations
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-orange-400 transition-colors duration-200">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Property Types */}
          <div>
            <h4 className="font-bold mb-4 text-white">Property Types</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>1BHK & 2BHK Apartments</li>
              <li>Studio Apartments</li>
              <li>Independent Houses</li>
              <li>Premium Villas</li>
              <li>Residential Plots</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold mb-4 text-white">Contact Us</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-orange-400 flex-shrink-0 mt-0.5" />
                <a href="tel:8679334866" className="text-gray-400 hover:text-orange-400 transition-colors duration-200">
                  8679334866
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-orange-400 flex-shrink-0 mt-0.5" />
                <a href="mailto:info@vrindavancalling.in" className="text-gray-400 hover:text-orange-400 transition-colors duration-200">
                  info@vrindavancalling.in
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-orange-400 flex-shrink-0 mt-0.5" />
                <p className="text-gray-400">
                  Suncity Anantam, Ramtal Jaint Road, Vrindavan
                </p>
              </div>
              <div className="pt-2">
                <button
                  onClick={() => window.open('https://wa.me/918679334866', '_blank')}
                  className="flex items-center space-x-2 text-green-400 hover:text-green-300 transition-colors duration-200"
                >
                  <MessageCircle className="w-5 h-5" />
                  <span>Chat on WhatsApp</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 text-center">
          <p className="text-gray-400 text-sm">
            Copyright © VRINDAVAN CALLING | MVDA & RERA Approved Properties
          </p>
        </div>
      </div>
    </footer>
  );
};